import {Injectable} from '@angular/core';

import {LayoutService} from 'app/core/services/layout.service';

@Injectable()
export class LayoutSwitcherService {
    constructor(private layout: LayoutService) {}

    resolve(): boolean {
        this.layout.forcedShowAsScrolled = true;
        return true;
    }
}
